// removed by extract-text-webpack-plugin
module.exports = {"root":"Author__root--1K3ne","featured":"Author__featured--39l6X","sidebar":"Author__sidebar--36WrD","bounce":"Author__bounce--3qdvy"};


//////////////////
// WEBPACK FOOTER
// ./src/author/components/Author/Author.css
// module id = ./src/author/components/Author/Author.css
// module chunks = 4